import * as React from 'react';
import { NavLink } from 'react-router-dom';
import propz from 'propz';
import { AppUser } from 'Src/views/App/App';
import { PROFILE_TABS_TITLES, PROFILE_TABS, PROFILE_TABS_URLS, PROFILE_TABS_ARRAY } from '../../../../consts/profile';
import './ProfileBar.scss';

interface Props {
  user: AppUser;
  isEditMode: boolean;
}

export function ProfileBar(props: Props) {
  const getTabs = () => {
    const { user } = props;
    const isEmailVerified = propz.get(user, ['profile', 'verification', 'status', 'email']);
    const isPhoneVerified = propz.get(user, ['profile', 'verification', 'status', 'sms']);
    const isUserVerified = isEmailVerified && isPhoneVerified;

    const tabs = isUserVerified
      ? [...PROFILE_TABS_ARRAY].filter(tab => tab !== PROFILE_TABS.VERIFICATION)
      : [...PROFILE_TABS_ARRAY];

    return tabs.map(tab => ({
      title: PROFILE_TABS_TITLES[tab],
      url: PROFILE_TABS_URLS[tab]
    }));
  };

  const { isEditMode } = props;

  return (
    <nav className="bProfileBar" aria-label="Profile sections">
      {getTabs().map((tab, index) => {
        const { title, url } = tab;
        return (
          <NavLink
            className={isEditMode ? 'eProfileBarItem mLinkDisabled' : 'eProfileBarItem'}
            activeClassName={'eProfileBarItem mProfileBarActive'}
            to={url}
            key={`profile_tab_title_${index}`}
          >
            {title}
          </NavLink>
        );
      })}
    </nav>
  );
}